import { InfoIcon } from 'lucide-react';

import type { CellRendererParams } from '@/grid/types';
import { cn } from '@/lib/utils';
import { ValidationMessageLevel } from '@/services/bulk-donor-scheduling';

import type { SheetState } from '../hooks/use-bulk-donor-scheduling-store';
import type { BulkDonorScheduleInput } from '../utils/schema';

export function CellRenderer({
  value,
  context,
  colDef,
  node,
}: CellRendererParams<BulkDonorScheduleInput> & { context: SheetState }) {
  const { errors, messages } = context;
  const name =
    colDef?.field && node.rowIndex !== null
      ? `${node.rowIndex}.${colDef.field}`
      : undefined;
  const error = name && errors?.[name];
  const message = name && messages?.[name];
  if (error || message) {
    const iconColor = error
      ? 'text-red-500'
      : message?.level === ValidationMessageLevel.WARNING
        ? 'text-amber-500'
        : 'text-emerald-500';

    return (
      <span className="flex w-full cursor-pointer flex-row items-center justify-between">
        <span className="px-3.5">{value}</span>
        <InfoIcon className={cn(iconColor)} />
      </span>
    );
  }

  return value;
}
